// @ts-strict-ignore
import { Component, inject, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Icon, ImageIcon } from "src/app/shared/type/widget";
import { ModalController } from "@ionic/angular";
import { InfoModalComponent } from "../modal/info-modal/info-modal";

@Component({
  selector: "oe-flat-widget",
  templateUrl: "./flat.html",
  styleUrls: ["./flat.css"],
  providers: [TranslateService, ModalController],
})
export class FlatWidgetComponent {
  /** Image in Header */
  @Input() public img?: ImageIcon;

  /** Icon in Header */
  @Input() public icon: Icon = null;

  /** BackgroundColor of the Header (light or dark) */
  @Input() public color: string;

  /** Title in Header */
  @Input() public title: string;

  /** This property defines what info text is pulled from the translation service when clicking on the info button of the widget */
  @Input() public info: string;

  private modalController = inject(ModalController);

  async showInfoModal() {
    const modal = await this.modalController.create({
      component: InfoModalComponent,
      componentProps: {
        title: this.title,
        info: this.info,
      },
    });
    return await modal.present();
  }
}
